
export default {
  name: 'BaseNavigatorProductCard',
  props: {
    stream: {
      type: Object,
      default: null,
    },
    theme: {
      type: String,
      default: 'light',
    },
  },
  computed: {
    auditorium() {
      if (this.stream.statistics?.articles?.viewsCount < 100) {
        return 'менее 100'
      } else {
        return this.stream.statistics?.articles?.viewsCount
      }
    },
    materials() {
      return (
        this.stream.statistics?.articles?.publishedCount +
        this.stream.statistics?.telegram?.publishedCount
      )
    },
  },
}
